<style lang="scss" scoped>
.estate-card {
  border: 1px solid #e7e6e6;
  display: flex;
  flex-flow: column;
  transition: border-color 0.15s ease-in-out;
  height: 100%;
  &:hover {
    border-color: #000000;
  }
  img {
    flex: none;
    width: 100%;
    object-fit: cover;
  }
  .ribbon {
    position: absolute;
    right: 25px;
    top: 30px;
    background: var(--black);
    color: #fff;
    padding: 0.5rem 1rem;
    transform: rotate(12deg);
    transform-origin: top right;
    text-align: center;
    p {
      font-weight: 500;
      line-height: 1.2;
      font-size: 0.9rem;
    }
  }
  .content {
    padding: 16px;
    height: 100%;
    h4 {
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 27px;
      margin-bottom: 16px;
      color: #000000;
      font-family: 'Open Sans';
      text-transform: inherit;
    }
    p {
      font-family: 'Open Sans';
      color: #6b6667;
      font-size: 16px;
      letter-spacing: 0;
      line-height: 22px;
      font-weight: normal;
    }
    svg {
      height: 21px;
      width: 21px;
    }
    .svg-text {
      color: #6b6667;
      font-family: 'Open Sans';
      font-size: 12px;
      letter-spacing: 0;
      line-height: 17px;
      font-weight: normal;
      margin: auto 18px auto 8px;
    }
  }
}
</style>

<template>
  <div>
    <a v-if="data" class="estate-card" :href="route(computedUrl, computedUrlParams)">
      <img class="dynamic-image" data-object-fit="cover" :src="data.pictures[0].urlLarge" :alt="data.name" />
      <div v-if="[3, 4, 5].includes(data.purposeStatus.id)" class="ribbon">
        <p v-if="data.purposeStatus.id === 3" class="text-cyan m-0">
          Dichtblij<br />
          <span class="text-white fw-b">Verkocht</span>
        </p>
        <p v-if="data.purposeStatus.id === 4" class="text-cyan m-0">
          Dichtblij<br />
          <span class="text-white fw-b">Verhuurd</span>
        </p>
        <p v-if="data.purposeStatus.id === 5 || data.purposeStatus.id === 6" class="text-cyan m-0">in <span class="text-white fw-b">Optie</span></p>
      </div>
      <div class="content d-flex flex-column justify-content-between">
        <h4>{{ data.name }}</h4>
        <p v-if="data.purpose">{{ formatPriceLabel(data.price, data.currency, data.purposeStatus.id, this.data.purpose.id) }}</p>
        <div>
          <div v-if="data.city" class="d-inline-flex flex-row justify-content-center">
            <svg-vue icon="locatie-vastgoed-c-orange"></svg-vue>
            <span class="svg-text">{{ data.city }}</span>
          </div>
          <div v-if="data.rooms" class="d-inline-flex flex-row justify-content-center">
            <svg-vue icon="bed-vastgoed-c-orange"></svg-vue>
            <span class="svg-text">{{ data.rooms }}</span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
    },
    url: {
      default: 'projects-estates-show',
    },
    urlParams: {
      default: () => {},
    },
  },
  data() {
    return {
      computedUrl: '',
      computedUrlParams: {},
    };
  },
  mounted() {
    if (!this.url) this.computedUrl = 'projects-estates-show';
    else this.computedUrl = this.url;

    if (!this.urlParams) this.computedUrlParams = { estateId: `${this.data.id }`};
    else this.computedUrlParams = { ...this.urlParams, estateId: `${this.data.id}` };
  },
  computed: {
    estateUrl() {
      const name = this.data.Name;

      const slug = this.slugMe(name);

      const base = this.purposeId === 2 ? '/te-huur' : '/te-koop';

      return `${base}/${this.data.city}/${this.data.zip}/${slug}/${this.data.id}`;
    },
  },
};
</script>
